import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState, useEffect, useRef } from 'react'
import { getDocflowEmployees } from '../../../../service/DocflowService'
import styles from './CreateDocModal.module.scss'

export default function SignerSelector({ signers, onChange }) {
  useInterfaceLanguage();
  const [employees, setEmployees] = useState([])
  const [query, setQuery]         = useState('')
  const [open, setOpen]           = useState(false)
  const wrapRef                   = useRef(null)

  useEffect(() => {
    getDocflowEmployees().then(r => setEmployees(r.data))
  }, [])

  useEffect(() => {
    const handler = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const suggestions = employees.filter(e => {
    if (signers.find(s => s.id === e.id)) return false
    if (!query) return true
    const q = query.toLowerCase()
    return (
      e.full_name?.toLowerCase().includes(q) ||
      e.department?.toLowerCase().includes(q) ||
      e.position?.toLowerCase().includes(q)
    )
  })

  function addSigner(emp) {
    onChange([...signers, emp])
    setQuery('')
    setOpen(false)
  }

  function removeSigner(id) {
    onChange(signers.filter(s => s.id !== id))
  }

  function moveUp(idx) {
    if (idx === 0) return
    const arr = [...signers]
    ;[arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]]
    onChange(arr)
  }

  function moveDown(idx) {
    if (idx === signers.length - 1) return
    const arr = [...signers]
    ;[arr[idx + 1], arr[idx]] = [arr[idx], arr[idx + 1]]
    onChange(arr)
  }

  return (
    <div className={styles.signerSelectorWrap}>
      {/* Selected chain */}
      {tr(signers.length > 0 && (
        <ol className={styles.signerChain}>
          {signers.map((s, idx) => (
            <li key={s.id} className={styles.signerItem}>
              <span className={styles.signerOrder}>{tr(idx + 1)}</span>
              <div className={styles.signerInfo}>
                <span className={styles.signerName}>{tr(s.full_name)}</span>
                <span className={styles.signerMeta}>{[s.position, s.department].filter(Boolean).join(' · ')}</span>
              </div>
              <div className={styles.signerActions}>
                <button
                  type="button"
                  className={styles.iconBtn}
                  onClick={() => moveUp(idx)}
                  disabled={idx === 0}
                  title={tr("Выше")}
                >▲</button>
                <button
                  type="button"
                  className={styles.iconBtn}
                  onClick={() => moveDown(idx)}
                  disabled={idx === signers.length - 1}
                  title={tr("Ниже")}
                >▼</button>
                <button
                  type="button"
                  className={`${styles.iconBtn} ${styles.removeBtn}`}
                  onClick={() => removeSigner(s.id)}
                  title={tr("Удалить")}
                >×</button>
              </div>
            </li>
          ))}
        </ol>
      ))}

      {/* Dropdown search */}
      <div className={styles.signerDropWrap} ref={wrapRef}>
        <input
          className={styles.signerInput}
          placeholder={tr("Добавить подписанта (поиск по имени / отделу)…")}
          value={query}
          onChange={e => { setQuery(e.target.value); setOpen(true) }}
          onFocus={() => setOpen(true)}
        />
        {tr(open && (
          <ul className={styles.signerDropList}>
            {tr(!suggestions.length && (
              <li className={styles.signerDropEmpty}>
                {employees.length === 0 ? tr("Загрузка…") : tr("Не найдено")}
              </li>
            ))}
            {suggestions.slice(0, 8).map(e => (
              <li
                key={e.id}
                className={styles.signerDropItem}
                onMouseDown={() => addSigner(e)}
              >
                <span className={styles.sdName}>{tr(e.full_name)}</span>
                <span className={styles.sdMeta}>{[e.position, e.department].filter(Boolean).join(' · ')}</span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}
